import React from 'react';
export const InventoryHeader = ({
  className = '',
  inventoryName = 'Inventory'
}) => /*#__PURE__*/React.createElement("span", {
  className: className
}, /*#__PURE__*/React.createElement("p", null, "Adding to ", inventoryName));